import { IUpdateReport } from "interfaces/Report";
import { updateReportService } from "../ReportServices";
import { fireToast } from "../sweetAlertConfig";

export function updateReportHandle({ pr, rec, report }: IUpdateReport) {
  updateReportService({
    pr: pr === 0 ? report.pr : pr,
    rec: rec === 0 ? report.rec : rec,
    report,
  })
    .then((res) => {
      if (res.data.status === true) {
        localStorage.setItem("message", "Relatório atualizado com sucesso.");
        window.location.reload();
      }
    })
    .catch((err) => {
      fireToast("Ocorreu um erro ao atualizar os dados de pagamento.");
    });
}
